import { useQuery } from '@tanstack/react-query';
import type {
  DashboardWidgetQuery,
  UrgentiResponse,
  MancantiResponse,
  GrammiNecessariResponse,
} from '@produzionejb/types';
import { api } from './api-client';

const QK = {
  urgenti: (q: Partial<DashboardWidgetQuery>) => ['dashboard', 'urgenti', q] as const,
  mancanti: (q: Partial<DashboardWidgetQuery>) => ['dashboard', 'mancanti', q] as const,
  grammiNecessari: (q: Partial<DashboardWidgetQuery>) => ['dashboard', 'grammiNecessari', q] as const,
};

function toQueryString(q: Partial<DashboardWidgetQuery>): string {
  const params = new URLSearchParams();
  if (q.periodId) params.set('periodId', q.periodId);
  const s = params.toString();
  return s ? `?${s}` : '';
}

export function useUrgenti(query: Partial<DashboardWidgetQuery> = {}) {
  return useQuery({
    queryKey: QK.urgenti(query),
    queryFn: () => api<UrgentiResponse>(`/api/dashboard/urgenti${toQueryString(query)}`),
    staleTime: 10_000,
  });
}

export function useMancanti(query: Partial<DashboardWidgetQuery> = {}) {
  return useQuery({
    queryKey: QK.mancanti(query),
    queryFn: () => api<MancantiResponse>(`/api/dashboard/mancanti${toQueryString(query)}`),
    staleTime: 10_000,
  });
}

export function useGrammiNecessari(query: Partial<DashboardWidgetQuery> = {}) {
  return useQuery({
    queryKey: QK.grammiNecessari(query),
    queryFn: () =>
      api<GrammiNecessariResponse>(`/api/dashboard/grammi-necessari${toQueryString(query)}`),
    staleTime: 10_000,
  });
}
